import axios from "axios";

import type { UserState } from "~/src/types";

export const updateUserMetaWithDispatch = (
  userState: UserState,
  dispatch: (arg0: { type: string; payload: { user: UserState } }) => void,
  key: string,
  value: unknown,
) => {
  userState.metadata = {
    ...userState.metadata,
    [key]: value,
  };

  axios
    .put(`auth/user/${userState.uuid}/metadata`, userState.metadata)
    .then(() => {
      dispatch({
        type: "MAIN_SET_USER",
        payload: { user: userState },
      });
    })
    .catch((err) => {
      console.error(err);
    });
};
